import { transition, verticalFadeIn } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import SimpleTrackStyles from '@stories/Components/Misc/Carousels/Carousel/MotionTrack/MotionTrack.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  height: 0px;
  margin-bottom: var(--announcementBarHeight);
  z-index: ${Layers.Navigation};
`;
const Inner = styled(SectionWrapper) `
  ${transition('height', 0.15, 'ease-in-out')};

  height: var(--announcementBarHeight);
  position: fixed;
  inset: 0;
  overflow: hidden;

  --sectionBackground: linear-gradient(90.04deg, #9f4a92 0%, #3271a9 100%);

  ${SectionWrapperStyles.Inner} {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow: hidden;

    padding-top: 6px;
    padding-bottom: 6px;

    color: ${brand.primary.white};
  }
`;
const ItemControls = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  gap: 10px;
  flex-shrink: 0;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  ${fonts.poppins.extraBold};

  span {
    min-width: 40px;
    text-align: center;
  }
`;
const ArrowControl = styled.div `
  cursor: pointer;
  user-select: none;

  svg {
    height: 14px;
    width: 14px;
    transform: rotate(90deg);
  }

  &:last-child {
    svg {
      transform: rotate(-90deg);
    }
  }
`;
const CloseButton = styled.div `
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  @media ${until(Device.TabletLarge)} {
    margin-left: 10px;
  }

  svg {
    width: 12px;
    height: 12px;

    g {
      stroke-width: 5px !important;
    }
  }
`;
const ActiveItemSection = styled(m.div) `
  flex-grow: 1;
  padding: 0px ${fluid(0, 25)};
  height: 100%;
  overflow: hidden;
  max-width: 100%;

  ${SimpleTrackStyles.Container} {
    overflow: hidden;
    height: 100%;
  }

  ${SimpleTrackStyles.Track} {
    height: 100%;
  }

  --visibleItems: 1;
`;
const SingleCarouselControl = styled.div `
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  transform: rotate(-90deg);
  &[data-direction='left'] {
    transform: rotate(90deg);
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }

  svg {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;
const CarouselItemContent = styled(m.div).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-in-view'] ? 'visible' : 'hidden',
    transition: {
        staggerChildren: 0.1,
        duration: 1,
    },
})) `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${fluid(4, 8)};
  overflow: hidden;
  flex-wrap: nowrap;
  height: 100%;

  @media ${until(Device.TabletLarge)} {
    padding: 0px 5px;
  }
`;
const CarouselItem = styled.li `
  flex: 0 0 calc(100% / var(--visibleItems) - (var(--itemPeek, 0px) / var(--visibleItems)));
  overflow: hidden;

  /* max-width: var(--width);
  overflow: hidden; */
`;
const CarouselIcon = styled(m.div).attrs(() => ({ variants: verticalFadeIn(15) })) `
  display: flex;
  flex-shrink: 0;

  svg {
    width: 17px;
    height: 17px;

    color: ${brand.tertiary.pink};
  }
`;
const CarouselTitle = styled(m.div).attrs(() => ({ variants: verticalFadeIn(15) })) `
  ${paragraphSmall};
  margin: 0;
  height: 100%;
  display: flex;
  gap: 4px;

  strong {
    flex-shrink: 0;
  }

  @media ${until(Device.TabletLarge)} {
    font-size: 10px;
    line-height: 12px;

    display: block;

    span {
      display: contents;
    }

    strong {
      ${fonts.poppins.extraBold};
    }

    flex-shrink: 1;
    min-width: 1px;
  }

  @media ${from(Device.TabletLarge)} {
    max-width: 85%;

    span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
const CarouselCta = styled(m.div).attrs(() => ({ variants: verticalFadeIn(15) })) `
  flex-shrink: 0;

  @media ${until(Device.TabletLarge)} {
    display: contents;

    ${fonts.poppins.extraBold};
    font-size: 10px;
    line-height: 12px;
  }

  a {
    @media ${from(Device.TabletLarge)} {
      text-decoration: none;
    }
    color: ${brand.primary.white};
  }

  ${paragraphSmall};
  margin: 0;

  &[data-desktop='true'] {
    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }

  &[data-mobile='true'] {
    @media ${from(Device.TabletLarge)} {
      display: none;
    }
  }
`;
export const AnnouncementBarStyles = {
    Container,
    Inner,
    ItemControls,
    ArrowControl,
    CloseButton,
    ActiveItemSection,
    CarouselItem,
    CarouselItemContent,
    CarouselTitle,
    CarouselCta,
    SingleCarouselControl,
    CarouselIcon,
};
